import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

import CaseMetricsComponent from './../Components/CaseMetricsComponent';
import EngineMetricsComponent from './../Components/EngineMetricsComponent';
import PerformanceMetricsComponent from './../Components/PerformanceMetricsComponent';
import ArtifactsMetricsComponent from './../Components/ArtifactsMetricsComponent';
import {
  builds as buildActions,
  dispatchers as dispatcherActions,
  fetchJobBuildsByJobIds,
  fetchScenariosByDispatcherIds,
  fetchJobLabels,
  jira as jiraActions,
  jobRelationships as jobRelationshipActions,
  jobs as jobActions,
  metrics as metricsActions,
  params as paramActions
} from './../actions';
import {
  metricsPageLatestFetchedJobs,
  getDispatchersByTypesAfterCaseMetricsDate,
  getMetricsByDateInfo,
  getMetricsPage,
  getMetricsJobName,
  getMetricsDispatcherJobName,
  getJobRelationshipsChildJobIds
} from './../reducers';
import { pageTypes, auth, metricsPagesHelper } from './../helpers';

let pageType = '';

export class MetricsContainer extends React.Component {
  static propTypes = {
    fetchBuilds: PropTypes.func.isRequired,
    fetchRecentDispatchersByType: PropTypes.func.isRequired,
    fetchJobsByDate: PropTypes.func.isRequired,
    fetchJobLabels: PropTypes.func.isRequired,
    fetchJobBuildsByJobIds: PropTypes.func.isRequired,
    fetchParamsByJobIds: PropTypes.func.isRequired,
    fetchMetricsByJobIds: PropTypes.func.isRequired,
    fetchJobRelationshipsByJobIds: PropTypes.func.isRequired,
    fetchMetricTestNodes: PropTypes.func.isRequired,
    fetchScenariosByDispatcherIds: PropTypes.func.isRequired,
    latestFetchedjobs: PropTypes.array,
    fetchLower: PropTypes.number,
    fetchUpper: PropTypes.number,
    dispatcherId: PropTypes.number,
    dispatchers: PropTypes.array,
    pageType: PropTypes.object,
    dispatcherType: PropTypes.string,
    jobName: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.array.isRequired
    ]),
    dispatcherJobName: PropTypes.string,
    refreshScans: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    jobRelationshipChildJobIds: PropTypes.array.isRequired
  };

  componentDidMount() {
    if (this.props.pageType !== pageTypes.EXPORTTESTS &&
    this.props.pageType !== pageTypes.CASEAMENDINGTESTS &&
    this.props.pageType !== pageTypes.CASEAMENDINGKPPTESTS)
    {
      this.props.fetchBuilds(metricsPagesHelper.FETCH_DAYS);
    }

    this.props.fetchRecentDispatchersByType(
      this.props.dispatcherType, metricsPagesHelper.FETCH_DAYS);
    const tomorrow = Moment().startOf('day').add(1, 'days').unix();
    const lower = Moment().startOf('day').subtract(7, 'days').unix();

    if (this.props.pageType !== pageTypes.EXPORTTESTS &&
      this.props.pageType !== pageTypes.CASEAMENDINGTESTS &&
      this.props.pageType !== pageTypes.CASEAMENDINGKPPTESTS) {
      this.props.fetchMetricTestNodes(
        this.props.jobName,
        this.props.fetchLower < lower ? this.props.fetchLower : lower
      );
    }

    this.props.fetchJobsByDate(
      [this.props.jobName, this.props.dispatcherJobName],
      lower,
      tomorrow
    );

    if (this.props.pageType !== pageTypes.EXPORTTESTS &&
      this.props.pageType !== pageTypes.CASEAMENDINGTESTS &&
      this.props.pageType !== pageTypes.CASEAMENDINGKPPTESTS &&
      this.props.pageType !== pageTypes.PERFORMANCEMETRICS)
    {
      this.props.refreshScans();
    }

  }

  componentDidUpdate(prevProps) {
    if (this.props.pageType !== pageTypes.EXPORTTESTS &&
      this.props.pageType !== pageTypes.CASEAMENDINGTESTS &&
      this.props.pageType !== pageTypes.CASEAMENDINGKPPTESTS) {
      this.props.fetchMetricTestNodes(
        this.props.jobName,
        this.props.fetchLower
      );
    }
    this.props.fetchJobsByDate(
      [this.props.jobName, this.props.dispatcherJobName],
      this.props.fetchLower,
      this.props.fetchUpper
    );

    if (this.props.latestFetchedjobs !== prevProps.latestFetchedjobs ||
      this.props.jobRelationshipChildJobIds !== prevProps.jobRelationshipChildJobIds) {
      const jobIds = this.props.latestFetchedjobs.map(j => j.id);
      this.props.fetchParamsByJobIds(
        jobIds.concat(this.props.jobRelationshipChildJobIds));
      this.props.fetchJobBuildsByJobIds(jobIds);
      this.props.fetchJobLabels(jobIds);
      this.props.fetchJobRelationshipsByJobIds(jobIds);
      this.props.fetchMetricsByJobIds(
        jobIds.concat(this.props.jobRelationshipChildJobIds));
    }


    if (this.props.dispatchers &&
       (this.props.dispatchers !== prevProps.dispatchers ||
         pageType !== this.props.pageType)) {
      const dispatcherJobIds = this.props.dispatchers.map(d => d.job_id);
      const dispatcherIds = this.props.dispatchers.map(d => d.id);
      this.props.fetchParamsByJobIds(dispatcherJobIds);
      this.props.fetchScenariosByDispatcherIds(dispatcherIds);
      pageType = this.props.pageType;
    }
  }

  render() {
    switch (this.props.pageType) {
      case pageTypes.CASEMETRICS:
        return <CaseMetricsComponent isAuthenticated = {this.props.isAuthenticated} />;
      case pageTypes.PERFORMANCEMETRICS:
      case pageTypes.CASEAMENDINGTESTS:
      case pageTypes.CASEAMENDINGKPPTESTS:
      case pageTypes.EXPORTTESTS:
      case pageTypes.JOBBENCHMARK:
        return <PerformanceMetricsComponent pageType = {this.props.pageType} />;
      case pageTypes.ARTIFACTSMETRICS:
        return <ArtifactsMetricsComponent />;
      case pageTypes.ENGINEMETRICS:
        return <EngineMetricsComponent />;
      default:
        return <div />;
    }
  }
}

export const mapStateToProps = (state) => {
  const dateInfo = getMetricsByDateInfo(state);
  const metricsPage = getMetricsPage(state);

  const notFetched = dateInfo.timestamp < dateInfo.lowerLatestFetch;
  const upper = notFetched ? dateInfo.lowerLatestFetch : dateInfo.upperLatestFetch;
  const lower = notFetched ? dateInfo.timestamp : dateInfo.lowerLatestFetch;

  const jobName = getMetricsJobName(state);
  const dispatcherJobName = getMetricsDispatcherJobName(state);
  const jobs = metricsPageLatestFetchedJobs(state)(jobName);
  const dispatchers =
    getDispatchersByTypesAfterCaseMetricsDate(state, metricsPage.dispatcherType);

  return {
    latestFetchedjobs: jobs,
    fetchUpper: upper,
    fetchLower: lower,
    dispatcherId: metricsPage.metricsInfo ?
      metricsPage.metricsInfo(state).dispatcherId :
      0,
    dispatchers: dispatchers,
    dispatcherType: metricsPage.dispatcherType,
    pageType: metricsPage.pageType,
    jobName: jobName,
    dispatcherJobName: dispatcherJobName,
    isAuthenticated: auth.checkAuthenticated(),
    jobRelationshipChildJobIds: getJobRelationshipsChildJobIds(state)
  };
};
export default connect(
  mapStateToProps,
  {
    fetchBuilds: buildActions.fetchBuilds,
    fetchRecentDispatchersByType: dispatcherActions.fetchRecentDispatchersByType,
    fetchJobsByDate: jobActions.fetchJobsByDate,
    fetchJobLabels,
    fetchJobBuildsByJobIds,
    fetchParamsByJobIds: paramActions.fetchParamsByJobIds,
    fetchMetricsByJobIds: metricsActions.fetchMetricsByJobIds,
    fetchJobRelationshipsByJobIds: jobRelationshipActions.fetchJobRelationshipsByJobIds,
    fetchMetricTestNodes: paramActions.fetchMetricTestNodes,
    fetchScenariosByDispatcherIds,
    refreshScans: jiraActions.refreshScans
  }
)(MetricsContainer);


// WEBPACK FOOTER //
// src/Containers/MetricsContainer.jsx